import { Component, OnInit, Input } from '@angular/core';
import { ResidentialService } from '../../residential.service';
import { DatePipe } from '@angular/common';
import { _ } from 'underscore';
import { holidays } from '../../../../../assets/holidays';
import { IMyDpOptions, IMyDate } from 'mydatepicker';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import * as moment from 'moment-timezone';
import { AdjustTimeService } from 'src/app/questionarie-signup/adjust-time.service';

@Component({
  selector: 'app-r-q5',
  templateUrl: './r-q5.component.html',
  styleUrls: ['./r-q5.component.css', '../residential-question.component.css'],
  providers: [DatePipe],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class RQ5Component implements OnInit {
  @Input() data: any;

  question;
  questions;
  user_bot = false;
  showbutton = true;
  userResponses = [];
  index;
  questionObj;
  deviceWidth;
  // hgHolidays: Array<any>;
  date;
  ans_date;
  public model: any;
  disableDays: Array<IMyDate> = [];
  disableAfter: IMyDate;
  public myDatePickerOptions: IMyDpOptions;
  timer;
  hgHolidays = holidays.hgHolidays;
  placeholderText = 'MM/DD/YYYY';
  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };
  tduRates: any;
  constructor(
    private residentialService: ResidentialService,
    private datePipe: DatePipe,
    private timeZoneService: AdjustTimeService
  ) {
    this.questions = this.residentialService.getQues();
    this.userResponses = this.residentialService.userResponse.userResponses;
    this.deviceWidth = this.residentialService.deviceWidth;
  }
  minDate = this.timeZoneService.updateTime('America/Chicago');
  maxDate = new Date(new Date().setDate(new Date().getDate() + 60));
  ngOnInit() {
    this.residentialService.dateModel = '';
    this.residentialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].res_question;
        this.questionObj = this.questions[i];
        this.index = i;
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj))
      this.getDateObjectBasedOnUserResponses();

    setInterval(() => {
      if (new Date().getUTCHours() - 6 >= 13) {
        this.disableDays.push({
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          day: new Date().getDate(),
        });
      }
    }, 1000);
    this.getTduRatesForAllUtilityNames();
    // this.setBlackOutDates();
    if(this.model == null || this.model == '')
    {
      this.showbutton = false;
    }

  }

  setBlackOutDates() {
    // this.hgHolidays = holidays.hgHolidays;
    holidays.hgHolidays.map((row: any) => {
      this.disableDays.push({
        year: row.year,
        month: row.month,
        day: row.day,
      });
    });
    const after60Days = new Date().setDate(new Date().getDate() + 60);
    this.disableAfter = {
      year: new Date(after60Days).getFullYear(),
      month: new Date(after60Days).getMonth() + 1,
      day: new Date(after60Days).getDate(),
    };
    const realday = this.getRealDay();
    let newDate = moment(new Date())
        .utc()
        .format('YYYY-MM-DD HH:mm:ss')
        .toString(),
      m = moment.utc(newDate);
    m.tz('America/Chicago');
    const cstTime = m.format('HHmm'),
      cstDate = m.format('MM-DD-YYYY'),
      lastday = new Date(
        new Date(cstDate).getFullYear(),
        new Date(cstDate).getMonth() + 1,
        0
      ).getDate(),
      month =
        cstTime < '1500' && new Date(cstDate).getDate() === lastday
          ? new Date(cstDate).getMonth() + 1
          : new Date().getMonth() + 1,
      day = cstTime < '1500' ? new Date(cstDate).getDate() : realday - 1;
    let datesDisabledUntil = {
      year: new Date().getFullYear(),
      month: month,
      day: day,
    };
    this.myDatePickerOptions = {
      // other options...
      dateFormat: 'mm/dd/yyyy',
      firstDayOfWeek: 'su',
      disableSince: this.disableAfter,
      disableDays: this.disableDays,
      disableWeekends: true,
      disableUntil: datesDisabledUntil,
      editableDateField: false,
      showClearDateBtn: false,
      selectorHeight: '100%',
      selectorWidth: '100%',
      openSelectorOnInputClick: true,
    };
  }

  getMonthForRealDay(realday) {
    var lastday = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      0
    ).getDate();
    return realday - 1 === 0
      ? new Date().getMonth()
      : new Date().getMonth() + 1;
  }

  getRealDay() {
    if (new Date().getDay() === 5) {
      return new Date().getDate() + 3;
    } else {
      var dd = _.filter(this.disableDays, {
        day: new Date().getDate(),
        month: new Date().getMonth() + 1,
      });
      return new Date().getDate();
    }
  }

  getDateObjectBasedOnUserResponses() {
    const obj = _.findWhere(this.userResponses, {
      res_question_id: this.questionObj._id,
    });
    // console.log.log(obj);
    if (!_.isEmpty(obj)) {
      this.date = obj.fieldValue;
      if (typeof this.date === 'string') {
        this.date = new Date(this.date);
      }
      this.model = this.date;
      this.residentialService.dateModel = this.model;
      this.ans_date = moment(new Date(this.model))
        .format('MM/DD/YYYY')
        .toString();
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }
    }
  }

  goNext() {
    clearTimeout(this.timer);
    if (this.deviceWidth < 768) {
      this.timer = setTimeout(() => {
        this.next();
      }, 0);
    }
  }

  pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  getDate() {
    this.date = this.dateObjectCstFormatted();
    this.ans_date = moment(new Date(this.model))
      .format('MM/DD/YYYY')
      .toString();
    this.user_bot = true;
    if (this.deviceWidth < 768) {
      this.goNext();
    }
  }

  dateObjectCstFormatted() {
    return moment(new Date(this.model))
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
  }

  next() {
    if (!this.model) {
      if (this.deviceWidth < 768) {
        this.residentialService.unSelectService({ currentId: this.data });
      }
    } else {
      this.user_bot = true;
      const Obj = {
        res_question_id: this.data,
        filedName: 'dateOfSwitch_sp',
        fieldValue: this.date,
      };
      this.residentialService.updateResponses(Obj);
      this.residentialService.messageService({ currentId: this.data });
    }
  }

  valueChanged(event) {
    if (event) {
      this.model = event.selectedValue;
      this.date = this.dateObjectCstFormatted();
      this.ans_date = moment(new Date(this.model))
        .format('MM/DD/YYYY')
        .toString();
      this.user_bot = true;
      if (this.deviceWidth < 768) {
        this.goNext();
      }else
      {
        if(!this.showbutton)
        {
          this.next();
        }
      }
    }
  }

  getTduRatesForAllUtilityNames() {
    this.residentialService
      .getTduIdForAllUtilityNames()
      .subscribe((res: any) => {
        this.tduRates = res;
        sessionStorage.setItem('tduRates', JSON.stringify(this.tduRates));
      });
  }
}
